import Vue from 'vue';
import Vuex from 'vuex';
import auth from './modules/auth';
import dashboardlist from './modules/dashboardlist';
Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        auth,   
        dashboardlist,
    },
    strict: !PRODUCTION,
});